<template>
    <div class="rejoignez-flc">
        <Navbar />
        <!--=============== HOME ===============-->
        <div class="section bg-white" id="home">
            <div class="hero-image">
                <div class="hero-text">
                    <h1 class="__title">Actualités</h1>
                </div>
            </div>
        </div>

        <div class="bg-white">
            <div class="content" id="banner">
                <div id="container_base" class="">
                    <div class="element">
                        <div class="image">
                            <img src="../assets/images/actualité1.png" alt="actualite">
                        </div>
                        <div class="contenu">
                            <h4><b>Le saka saka de FLC est désormais disponible sur la capitale</b></h4>
                            <p>Le délicieux saka saka de FLC est disponible sur la capitale. Pour passer votre commande, 
                                vous avez deux options: le site web ou discuter directement avec le service client sur WhatsApp 06 667 5332 <br>
                                Bon appétit 😎🙏</p>
                                <span>Lun 17/07/23</span>
                        </div>
                    </div>
                    <div class="element">
                        <div class="image">
                            <img src="../assets/images/flc-insta1.png" alt="actualite" class="border">
                        </div>
                        <div class="contenu">
                            <h4><b>Lancement officiel du site web de FLC</b></h4>
                            <p>Le site web est désormais disponible . Il est possible de passer les commandes directement 
                            sur WhatsApp en cliquant sur le bouton « Chattez avec nous sur WhatsApp »</p>
                            <span>Mar 18/04/23</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <Footer />
    </div>
</template>

<script>
    import Navbar from "../components/Navbar.vue";
    import Footer from "../components/Footer.vue";

    export default {
        name: "Actualites",
        components: {
            Navbar,
            Footer,
        },
        data() {
            return {
            };
        },
    }
</script>

<style scoped>

    #container_base {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        width: 100%;
        height: auto;
    }

    .element {
        width: 280px;
        height: auto;
        margin: 20px;
   }

   .contenu {
    margin-top: 10px;
    text-align: justify;
   }

    .content {
        padding: 2rem 0 2rem;
    }

    .__title {
        line-height: 60px;
        color: #fff;
        transition: .2s;
        font-size: 48px;
        font-weight: bold;
    }

    .hero-image {
        background-image: url("../assets/images/news.jpg");
        background-color: #cccccc;
        height: 460px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }

    .hero-text {
        text-align: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }


    @media (max-width: 767px) {

        .hero-image {
            top: -90px;
            margin-bottom: 0px;
        }

        .section {
            padding: 4.5rem 0 0.5rem;
        }

        #container_base {
            justify-content: center;
        }

        .content {
            padding: 0.3rem 0 0.5rem;
        }

        .__title {
            line-height: 40px;
            color: #fff;
            transition: .2s;
            font-size: 37px;
            font-weight: bold;
        }

        .element {
            width: auto;
            height: auto;
            margin: 20px;
        }
    }

    @media (min-width: 768px) {
        .section {
            padding: 3rem 0 2rem;
        }
    }
</style>